import { api } from '../createApi';
import { computeVisibility } from '../methods/workflows/utils';
import { TagType } from '../TagType';
import { TAG_ROUTINGS_BY_LIST } from './routings';

export const TAG_WORKFLOWS_BY_LIST = { type: TagType.Workflows, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Workflows],
  endpoints: {
    deleteWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST, TAG_ROUTINGS_BY_LIST],
    },
    createWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST],
    },
    duplicateWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST],
    },
    getAvailableWorkflows: {
      providesTags: [TAG_WORKFLOWS_BY_LIST],
    },
    getWorkflows: {
      providesTags: [TAG_WORKFLOWS_BY_LIST],
    },
    publishWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST, TAG_ROUTINGS_BY_LIST],
    },
    saveAndPublishWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST, TAG_ROUTINGS_BY_LIST],
    },
    unpublishWorkflow: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST, TAG_ROUTINGS_BY_LIST],
    },
    updateWorkflowShareSettings: {
      invalidatesTags: [TAG_WORKFLOWS_BY_LIST],
      onQueryStarted(
        { workflowId, shareSettings, currentUserId },
        { dispatch, queryFulfilled },
      ) {
        queryFulfilled.then(() => {
          dispatch(
            api.util.updateQueryData(
              'getWorkflowShareSettings',
              { workflowId, currentUserId },
              () => ({
                hasSettings: true,
                visibility: computeVisibility(
                  shareSettings.userIds,
                  shareSettings.departmentIds,
                  currentUserId,
                ),
                userIds: shareSettings.userIds,
                departmentIds: shareSettings.departmentIds,
              }),
            ),
          );
        });
      },
    },
  },
});
